module.exports = __webpack_public_path__ + "static/img/Gacha20.ccdd961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha20.png
// module id = 7O6s
// module chunks = 1